import { withMetadata } from '../metadata'
import { getExampleNumber as _getExampleNumber } from '../../core/index'

export function getExampleNumber() {
	return withMetadata(_getExampleNumber, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/getExampleNumber.js
// module id = SqXM
// module chunks = 0 1